import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useQuestionnaires = (projectId: string, questionnaireId: string) => {
  const p = projectId ? ENDPOINTS.QUESTIONNAIRES.byQuestionnaireId(projectId, questionnaireId) : null
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
